import React from "react";
import { Tabs } from "antd"
import { useTranslation } from "react-i18next";
import NotificationTestComponent from "./Notifications";

const { TabPane } = Tabs;

const AllNotificationsComponent = () => {
  const { t } = useTranslation()
  return (
    <Tabs defaultActiveKey="1">
      <TabPane tab={t('Notifications')} key="1">
        <NotificationTestComponent />
      </TabPane>
    </Tabs >
  )
}

export default AllNotificationsComponent